module.exports = __webpack_public_path__ + "static/media/profile.6489ee2a.svg";